export default "__VITE_ASSET__BAoN2QLo__"